/**
 * Questionnaire v2 — Étapes 9 à 13
 * Table d'honneur, arche, chaises, accessoires, contenants
 */
(function () {
  'use strict';

  let initialized = false;
  let step9SubGallery = null;
  let step10ArcheGallery = null;

  const step9SubSwipers = {};
  let supportSwiper = null;

  let tableHonneurChoice = null;
  let tableHonneurFreshSuboption = null;
  let tableHonneurPrice = 0;
  let tableHonneurBasePrice = 0;

  let archeChoice = null;
  let archeFlowers = 0;
  let archePrice = 0;
  let archeBasePrice = 0;
  let supportChoice = null;
  let supportPrice = 0;
  let supportForm = null;

  let chairChoice = null;
  let chairPrice = 0;
  let chairBasePrice = 0;
  let chairQuantity = 0;

  let accessoriesChoice = null;
  let accessoriesPrice = 0;

  function getUncroppedImageUrl(rawUrl) {
    if (!rawUrl || typeof rawUrl !== 'string') return rawUrl;
    let url = rawUrl.trim().replace(/&amp;/g, '&');
    url = url.replace(/_\d+x\d+_crop_center(?=\.)/i, '');
    url = url.replace(/_crop_center(?=\.)/i, '');
    url = url.replace(/_\d+x\d+(?=\.)/i, '');
    url = url.replace(/_\d+x(?=\.)/i, '');
    url = url.replace(/_x\d+(?=\.)/i, '');
    url = url.replace(/([?&])width=\d+(&|$)/i, '$1');
    url = url.replace(/([?&])height=\d+(&|$)/i, '$1');
    url = url.replace(/([?&])crop=[^&]*(&|$)/i, '$1');
    url = url.replace(/\?&/, '?').replace(/&&/g, '&').replace(/[?&]$/, '');
    return url;
  }

  function parsePriceFromText(text) {
    const match = String(text || '').match(/(\d+(?:[.,]\d+)?)/);
    return match ? parseFloat(match[1].replace(',', '.')) : 0;
  }

  function runWhenSwiperReady(callback, maxAttempts) {
    const limit = maxAttempts || 80;
    let attempts = 0;
    function tryRun() {
      attempts++;
      if (typeof Swiper !== 'undefined') {
        callback(true);
        return;
      }
      if (attempts < limit) {
        setTimeout(tryRun, 50);
      } else {
        callback(false);
      }
    }
    tryRun();
  }

  function resizeShopifyImageUrl(url, width) {
    if (!url || typeof url !== 'string') return '';
    if (url.indexOf('width=') !== -1) {
      return url.replace(/width=\d+/, 'width=' + width);
    }
    return url;
  }

  function setValidationButtonState(button, disabled) {
    if (button) button.disabled = disabled;
  }

  function getColorImagesFromSelect(selectEl, colorName) {
    if (!selectEl || !colorName) return [];
    const option = Array.from(selectEl.options).find(function (opt) {
      return opt.value === colorName;
    });
    if (!option) return [];
    const raw = option.getAttribute('data-color-images') || '';
    return raw.split('|||').map(function (u) { return u.trim(); }).filter(Boolean);
  }

  function bindImageErrorRecovery(img) {
    if (!img || img.dataset.qv2ImgRecovery) return;
    img.dataset.qv2ImgRecovery = '1';
    img.addEventListener('error', function () {
      if (img.dataset.qv2ImgRetried === '1') return;
      const fallback = img.getAttribute('data-fallback-src') ||
        img.getAttribute('data-lightbox-src') ||
        img.getAttribute('data-src');
      if (!fallback) return;
      img.dataset.qv2ImgRetried = '1';
      const clean = fallback.replace(/([&?])_qrb=\d+/g, '$1').replace(/\?&/, '?').replace(/[?&]$/, '');
      if (clean && img.src !== clean) {
        img.src = clean;
      }
    });
  }

  function forceLoadImage(img, url, lightboxUrl) {
    if (!img || !url) return;
    const currentBase = (img.getAttribute('src') || '').replace(/([&?])_qrb=\d+/g, '$1').split('?')[0];
    const nextBase = url.split('?')[0];
    if (currentBase === nextBase) {
      if (img.complete && img.naturalWidth > 0) return;
      if (!img.complete) return;
    }
    img.loading = 'eager';
    img.classList.remove('lazyload', 'lazyloaded', 'lazyloading');
    img.removeAttribute('data-src');
    img.src = url;
    if (lightboxUrl) {
      img.setAttribute('data-lightbox-src', lightboxUrl);
      img.setAttribute('data-fallback-src', url);
    }
    bindImageErrorRecovery(img);
  }

  function ensureTableHonneurImage(optionEl, url, lightboxUrl) {
    if (!optionEl || !url || optionEl.id === 'support-product-display') return null;
    let wrap = optionEl.querySelector('.table-honneur-image');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'table-honneur-image';
      const insertBefore = optionEl.querySelector('.table-honneur-title, .table-honneur-color-selector');
      if (insertBefore) optionEl.insertBefore(wrap, insertBefore);
      else optionEl.prepend(wrap);
      wrap.innerHTML =
        '<img alt="" loading="eager" decoding="async"/>' +
        '<button type="button" class="image-zoom-btn" aria-label="Agrandir l\'image"></button>';
    }
    const img = wrap.querySelector('img');
    const zoomBtn = wrap.querySelector('.image-zoom-btn');
    if (img) forceLoadImage(img, url, lightboxUrl || url);
    if (zoomBtn) zoomBtn.setAttribute('data-lightbox-src', lightboxUrl || url);
    return img;
  }

  let questionnaireMediaCache = null;

  function invalidateQuestionnaireMediaCache() {
    questionnaireMediaCache = null;
    window.__QV2_QUESTIONNAIRE_MEDIA__ = null;
  }

  function getQuestionnaireMediaData(forceReload) {
    if (!forceReload && questionnaireMediaCache) return questionnaireMediaCache;
    if (!forceReload && window.__QV2_QUESTIONNAIRE_MEDIA__) {
      questionnaireMediaCache = window.__QV2_QUESTIONNAIRE_MEDIA__;
      return questionnaireMediaCache;
    }
    const el = document.getElementById('qv2-questionnaire-media-data') ||
      document.getElementById('questionnaire-media-data');
    if (!el) return null;
    try {
      questionnaireMediaCache = JSON.parse(el.textContent);
      window.__QV2_QUESTIONNAIRE_MEDIA__ = questionnaireMediaCache;
    } catch (e) {
      console.warn('[QV2] questionnaire-media-data invalide:', e);
      questionnaireMediaCache = null;
    }
    return questionnaireMediaCache;
  }

  function reloadStepImages(stepEl) {
    if (!stepEl) return;
    stepEl.querySelectorAll('img').forEach(function (img) {
      const src = img.getAttribute('src') ||
        img.getAttribute('data-fallback-src') ||
        img.getAttribute('data-lightbox-src');
      if (!src || src.indexOf('data:') === 0) return;
      img.loading = 'eager';
      img.classList.remove('lazyload', 'lazyloaded', 'lazyloading');
      img.removeAttribute('data-src');
      if (!img.getAttribute('src')) {
        img.src = src;
      }
      bindImageErrorRecovery(img);
    });
  }

  function fixBrokenImagesInStep(stepEl) {
    if (!stepEl) return;
    stepEl.querySelectorAll('img').forEach(function (img) {
      const fallback = img.getAttribute('data-fallback-src') ||
        img.getAttribute('data-lightbox-src') ||
        img.getAttribute('data-src');
      if (!fallback) return;
      const current = img.getAttribute('src') || '';
      if (!current || current.indexOf('data:') === 0) {
        forceLoadImage(img, fallback, img.getAttribute('data-lightbox-src') || fallback);
        return;
      }
      if (img.complete && img.naturalWidth === 0) {
        forceLoadImage(img, fallback, img.getAttribute('data-lightbox-src') || fallback);
      }
    });
  }

  const STEP_VISUAL_SELECTORS = {
    9: {
      step9_fresh: '#table-honneur-fresh',
      step9_artificial: '#table-honneur-artificial',
      step9_fresh_sub_1: '#fresh-suboption-1',
      step9_fresh_sub_2: '#fresh-suboption-2',
      step9_fresh_sub_3: '#fresh-suboption-3',
      step9_fresh_sub_4: '#fresh-suboption-4'
    },
    10: {
      step10_arch_fresh: '#arche-fresh',
      step10_arch_artificial: '#arche-artificial'
    },
    11: {
      step11_fresh: '#step11-fresh-option',
      step11_artificial: '#step11-artificial-option'
    }
  };

  function hydrateStepVisualsByKey(stepEl, stepNumber) {
    if (!stepEl) return;

    stepEl.querySelectorAll('[data-q-thumb]').forEach(function (optionEl) {
      if (optionEl.hasAttribute('data-step9-images-full')) return;
      const thumbUrl = optionEl.getAttribute('data-q-thumb');
      const fullUrl = optionEl.getAttribute('data-q-full') || thumbUrl;
      if (thumbUrl) ensureTableHonneurImage(optionEl, thumbUrl, fullUrl);
    });

    const data = getQuestionnaireMediaData();
    if (!data) return;

    const visuals = data.stepVisuals;
    const selectors = STEP_VISUAL_SELECTORS[stepNumber];
    if (visuals && selectors) {
      Object.keys(selectors).forEach(function (visualKey) {
        const url = visuals[visualKey];
        if (!url) return;
        const optionEl = stepEl.querySelector(selectors[visualKey]);
        if (!optionEl || optionEl.hasAttribute('data-step9-images-full')) return;
        const thumbUrl = resizeShopifyImageUrl(url, 600) || url;
        ensureTableHonneurImage(optionEl, thumbUrl, url);
      });
    }

    const stepUrls = data.steps && data.steps[String(stepNumber)] ? data.steps[String(stepNumber)] : null;
    if (!stepUrls) return;

    if (stepNumber === 9) {
      if (stepUrls.fresh) {
        ensureTableHonneurImage(stepEl.querySelector('#table-honneur-fresh'), stepUrls.fresh, stepUrls.fresh);
      }
      if (stepUrls.artificial) {
        ensureTableHonneurImage(stepEl.querySelector('#table-honneur-artificial'), stepUrls.artificial, stepUrls.artificial);
      }
    }
    if (stepNumber === 10) {
      if (stepUrls.archFresh) {
        ensureTableHonneurImage(stepEl.querySelector('#arche-fresh'), stepUrls.archFresh, stepUrls.archFresh);
      }
      if (stepUrls.archArtificial) {
        ensureTableHonneurImage(stepEl.querySelector('#arche-artificial'), stepUrls.archArtificial, stepUrls.archArtificial);
      }
    }
    if (stepNumber === 11) {
      if (stepUrls.fresh) {
        ensureTableHonneurImage(stepEl.querySelector('#step11-fresh-option'), stepUrls.fresh, stepUrls.fresh);
      }
      if (stepUrls.artificial) {
        ensureTableHonneurImage(stepEl.querySelector('#step11-artificial-option'), stepUrls.artificial, stepUrls.artificial);
      }
    }
  }

  function hydrateArcheColorSlides(archeColors) {
    if (!archeColors) return;
    Object.keys(archeColors).forEach(function (colorName) {
      const colorData = archeColors[colorName];
      const images = (colorData && colorData.images) || [];
      const thumb = (colorData && colorData.thumb) || images[0];
      if (!thumb && !images.length) return;
      document.querySelectorAll('.arche-color-slide[data-color-name="' + CSS.escape(colorName) + '"]').forEach(function (slide, index) {
        const img = slide.querySelector('img');
        const displayUrl = images[index] || thumb;
        const lightboxUrl = images[index] || images[images.length - 1] || thumb;
        if (img && displayUrl) {
          const display600 = resizeShopifyImageUrl(displayUrl, 600) || displayUrl;
          forceLoadImage(img, display600, lightboxUrl);
        }
      });
    });
  }

  function applyAccessoryCardImage(accessoryCard, imageUrls) {
    if (!accessoryCard || !imageUrls || !imageUrls.length) return;
    const thumb = resizeShopifyImageUrl(imageUrls[0], 400) || imageUrls[0];
    const lb = imageUrls[imageUrls.length - 1] || thumb;
    const wrap = accessoryCard.querySelector('.accessory-item-image, .container-item-image');
    const img = wrap && wrap.querySelector('img');
    if (!img) {
      ensureTableHonneurImage(accessoryCard, thumb, lb);
      return;
    }
    forceLoadImage(img, thumb, lb);
    const zoom = accessoryCard.querySelector('.image-zoom-btn');
    if (zoom) zoom.setAttribute('data-lightbox-src', lb);
  }

  function hydrateStep12Accessories(accessories) {
    if (!accessories) return;
    document.querySelectorAll('.step12-accessories-option').forEach(function (card) {
      const accessoryId = card.getAttribute('data-accessory-id');
      const accData = accessories[accessoryId];
      if (!accData || !accData.colors) return;
      let firstImages = (card.getAttribute('data-accessory-first-images') || '').split('|||').filter(Boolean);
      if (!firstImages.length) {
        Object.keys(accData.colors).some(function (colorName) {
          const colorEntry = accData.colors[colorName];
          if (colorEntry.images && colorEntry.images.length) {
            firstImages = colorEntry.images;
            return true;
          }
          return false;
        });
      }
      if (firstImages.length) applyAccessoryCardImage(card, firstImages);
    });
  }

  function hydrateQuestionnaireStepMedia(stepNumber) {
    const stepEl = document.querySelector('.questionnaire-step[data-step="' + stepNumber + '"]');
    if (!stepEl) return;

    const data = getQuestionnaireMediaData();
    if (data) {
      if (stepNumber === 9 || stepNumber === 10 || stepNumber === 11) {
        hydrateStepVisualsByKey(stepEl, stepNumber);
      }
      if (stepNumber === 10 && data.archeColors) {
        hydrateArcheColorSlides(data.archeColors);
      }
      if (stepNumber === 12 && data.accessories) {
        hydrateStep12Accessories(data.accessories);
      }
    }

    reloadStepImages(stepEl);
    fixBrokenImagesInStep(stepEl);

    if (stepNumber === 12) {
      document.querySelectorAll('.step12-accessories-option').forEach(function (card) {
        const urls = (card.getAttribute('data-accessory-first-images') || '').split('|||').filter(Boolean);
        if (urls.length) applyAccessoryCardImage(card, urls);
      });
      initStep12AccessoryDefaultPrices();
    }

    if (stepNumber === 13) {
      stepEl.querySelectorAll('.container-item, .gift-bag-item').forEach(function (card) {
        const img = card.querySelector('.container-item-image img, .gift-bag-item-image img');
        if (img) {
          const src = img.getAttribute('src') || img.getAttribute('data-fallback-src');
          if (src) forceLoadImage(img, src, img.getAttribute('data-lightbox-src') || src);
        }
      });
    }
  }

  function getLightboxEl() {
    return document.getElementById('questionnaire-image-lightbox');
  }

  function getLightboxImageEl() {
    return document.getElementById('lightbox-image');
  }

  function getLightboxCloseEl() {
    return document.getElementById('lightbox-close');
  }

  function openLightbox(imageSrc) {
    if (window.QV2 && typeof window.QV2.openImageLightbox === 'function') {
      return window.QV2.openImageLightbox(imageSrc);
    }
    const lightbox = getLightboxEl();
    const lightboxImage = getLightboxImageEl();
    if (lightbox && lightboxImage && imageSrc) {
      lightboxImage.src = getUncroppedImageUrl(imageSrc);
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';
      return true;
    }
    return false;
  }

  function closeLightbox() {
    const lightbox = getLightboxEl();
    if (lightbox) {
      lightbox.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  class ImageGalleryModal {
    constructor(config) {
      this.modal = document.getElementById(config.modalId);
      this.modalImage = document.getElementById(config.imageId);
      this.modalCounter = document.getElementById(config.counterId);
      this.modalTitle = document.getElementById(config.titleId);
      this.modalPrev = document.getElementById(config.prevId);
      this.modalNext = document.getElementById(config.nextId);
      this.modalClose = document.getElementById(config.closeId);
      this.modalOverlay = this.modal ? this.modal.querySelector('.modal-overlay') : null;
      this.modalSelectBtn = document.getElementById(config.selectBtnId);
      this.onSelect = config.onSelect || null;
      this.images = [];
      this.currentIndex = 0;
      this.currentTitle = '';
      this.currentElement = null;
      this.minSwipeDistance = 50;
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.touchStartY = 0;
      this.touchEndY = 0;
      this.init();
    }

    init() {
      if (this.modalPrev) this.modalPrev.addEventListener('click', () => this.goToPrevious());
      if (this.modalNext) this.modalNext.addEventListener('click', () => this.goToNext());
      if (this.modalClose) this.modalClose.addEventListener('click', () => this.close());
      if (this.modalOverlay) this.modalOverlay.addEventListener('click', () => this.close());
      if (this.modalSelectBtn) this.modalSelectBtn.addEventListener('click', () => this.handleSelect());

      if (this.modalImage) {
        this.modalImage.addEventListener('dblclick', () => this.handleSelect());
        this.modalImage.addEventListener('touchstart', (e) => {
          this.touchStartX = e.changedTouches[0].screenX;
          this.touchStartY = e.changedTouches[0].screenY;
        }, { passive: true });
        this.modalImage.addEventListener('touchend', (e) => {
          this.touchEndX = e.changedTouches[0].screenX;
          this.touchEndY = e.changedTouches[0].screenY;
          const deltaX = this.touchEndX - this.touchStartX;
          const deltaY = this.touchEndY - this.touchStartY;
          if (Math.abs(deltaX) > this.minSwipeDistance && Math.abs(deltaX) > Math.abs(deltaY)) {
            if (deltaX > 0) this.goToPrevious();
            else this.goToNext();
          }
        }, { passive: true });
      }
    }

    open(item, imagesData, title, imageCount) {
      if (!imagesData || imagesData === '' || imageCount === 0) return false;
      this.images = imagesData.split('|||');
      this.currentIndex = 0;
      this.currentTitle = title;
      this.currentElement = item;
      this.loadImage(this.images[0], 1, this.images.length);
      if (this.modal) {
        this.modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
      return true;
    }

    loadImage(imageUrl, index, total) {
      if (this.modalImage) this.modalImage.src = getUncroppedImageUrl(imageUrl);
      if (this.modalCounter) this.modalCounter.textContent = index + ' / ' + total;
      if (this.modalTitle) this.modalTitle.textContent = this.currentTitle;
      if (this.modalPrev) this.modalPrev.disabled = index === 1;
      if (this.modalNext) this.modalNext.disabled = index === total;
    }

    goToPrevious() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.loadImage(this.images[this.currentIndex], this.currentIndex + 1, this.images.length);
      }
    }

    goToNext() {
      if (this.currentIndex < this.images.length - 1) {
        this.currentIndex++;
        this.loadImage(this.images[this.currentIndex], this.currentIndex + 1, this.images.length);
      }
    }

    close() {
      if (this.modal) {
        this.modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    handleSelect() {
      if (this.currentElement && this.onSelect) {
        this.onSelect(this.currentElement);
        this.close();
      }
    }
  }

  function setupNoOptionButton(noButton, itemsToDeselect, onToggle, onValidation) {
    if (!noButton || noButton.dataset.qv2NoBound) return;
    noButton.dataset.qv2NoBound = '1';

    noButton.addEventListener('click', function () {
      this.classList.toggle('selected');
      if (this.classList.contains('selected')) {
        if (typeof itemsToDeselect === 'string') {
          document.querySelectorAll(itemsToDeselect).forEach(function (item) {
            item.classList.remove('selected');
          });
        } else if (Array.isArray(itemsToDeselect)) {
          itemsToDeselect.forEach(function (item) {
            if (item) item.classList.remove('selected');
          });
        }
      }
      if (onToggle) onToggle(this.classList.contains('selected'));
      if (onValidation) onValidation();
    });
  }

  function initLightboxBindings() {
    const lightboxClose = getLightboxCloseEl();
    const lightbox = getLightboxEl();
    const lightboxOverlay = lightbox ? lightbox.querySelector('.lightbox-overlay') : null;
    if (lightboxClose && !lightboxClose.dataset.qv2Bound) {
      lightboxClose.dataset.qv2Bound = '1';
      lightboxClose.addEventListener('click', closeLightbox);
    }
    if (lightboxOverlay && !lightboxOverlay.dataset.qv2Bound) {
      lightboxOverlay.dataset.qv2Bound = '1';
      lightboxOverlay.addEventListener('click', closeLightbox);
    }
    if (!document.body.dataset.qv2LightboxEsc) {
      document.body.dataset.qv2LightboxEsc = '1';
      document.addEventListener('keydown', function (e) {
        const activeLightbox = getLightboxEl();
        if (e.key === 'Escape' && activeLightbox && activeLightbox.classList.contains('active')) {
          closeLightbox();
        }
      });
    }
  }

  function initZoomDelegation() {
    if (document.body.dataset.qv2ZoomDelegation) return;
    document.body.dataset.qv2ZoomDelegation = '1';

    document.addEventListener('click', function (e) {
      if (e.target.closest('.material-help-btn')) return;

      const zoomBtn = e.target.closest('.image-zoom-btn');
      if (!zoomBtn) return;

      e.preventDefault();
      e.stopPropagation();

      const step9Sub = zoomBtn.closest('.table-honneur-suboption');
      if (step9Sub) {
        openStep9SuboptionGallery(step9Sub);
        return;
      }

      const archeFresh = zoomBtn.closest('#arche-fresh');
      if (archeFresh) {
        openStep10ArcheFreshGallery(archeFresh);
        return;
      }

      const archeArtificial = zoomBtn.closest('#arche-artificial');
      if (archeArtificial) {
        openStep10ArcheArtificialGallery(archeArtificial);
        return;
      }

      const chairFresh = zoomBtn.closest('#step11-fresh-option');
      if (chairFresh) {
        openStep11ChairFreshGallery(chairFresh);
        return;
      }

      const chairArtificial = zoomBtn.closest('#step11-artificial-option');
      if (chairArtificial) {
        openStep11ChairArtificialGallery(chairArtificial);
        return;
      }

      const containerItem = zoomBtn.closest('.container-item, .gift-bag-item');
      if (containerItem) {
        openProductCardGallery(containerItem);
        return;
      }

      const src = zoomBtn.getAttribute('data-lightbox-src') ||
        ((window.QV2 && window.QV2.resolveZoomImageSrc) ? window.QV2.resolveZoomImageSrc(zoomBtn) : '');
      if (src) {
        openLightbox(src);
      }
    }, true);
  }

  function collectImagesFromEl(el, dataAttr) {
    if (!el) return [];
    const seen = Object.create(null);
    const images = [];
    function pushIfNew(url) {
      if (!url || typeof url !== 'string') return;
      const clean = getUncroppedImageUrl(url.trim());
      if (!clean || seen[clean]) return;
      seen[clean] = true;
      images.push(clean);
    }
    const fullRaw = el.getAttribute(dataAttr || 'data-step9-images-full') || el.getAttribute('data-product-images-full') || '';
    if (fullRaw) fullRaw.split('|||').forEach(pushIfNew);
    if (images.length === 0) {
      pushIfNew(el.getAttribute('data-q-full'));
      pushIfNew(el.getAttribute('data-q-thumb'));
      el.querySelectorAll('img').forEach(function (img) {
        pushIfNew(img.getAttribute('data-lightbox-src'));
        pushIfNew(img.getAttribute('data-fallback-src'));
        pushIfNew(img.getAttribute('src'));
      });
    }
    return images;
  }

  function openStep9SuboptionGallery(suboptionItem) {
    const images = collectImagesFromEl(suboptionItem, 'data-step9-images-full');
    const titleEl = suboptionItem.querySelector('.table-honneur-title');
    const title = titleEl ? titleEl.textContent.trim() : '';
    if (images.length > 0 && step9SubGallery) {
      step9SubGallery.open(suboptionItem, images.join('|||'), title, images.length);
      return;
    }
    const fallback = suboptionItem.querySelector('.image-zoom-btn');
    if (fallback) {
      const src = fallback.getAttribute('data-lightbox-src') ||
        ((window.QV2 && window.QV2.resolveZoomImageSrc) ? window.QV2.resolveZoomImageSrc(fallback) : '');
      if (src) openLightbox(src);
    }
  }

  function openStep10ArcheFreshGallery(archeItem) {
    const images = collectImagesFromEl(archeItem, 'data-step10-images-full');
    const titleEl = archeItem.querySelector('.table-honneur-title');
    const title = titleEl ? titleEl.textContent.trim() : '';
    if (images.length > 0 && step10ArcheGallery) {
      step10ArcheGallery.open(archeItem, images.join('|||'), title, images.length);
    }
  }

  function openStep10ArcheArtificialGallery(archeItem) {
    const archeColorSelect = document.getElementById('arche-color');
    const images = [];
    const selectedColor = archeColorSelect && archeColorSelect.value;
    if (selectedColor) {
      getColorImagesFromSelect(archeColorSelect, selectedColor).forEach(function (u) { images.push(u); });
    }
    if (images.length === 0) {
      collectImagesFromEl(archeItem, 'data-step10-images-full').forEach(function (u) { images.push(u); });
    }
    const titleEl = archeItem.querySelector('.table-honneur-title');
    const title = titleEl ? titleEl.textContent.trim() : '';
    if (images.length > 0 && step10ArcheGallery) {
      step10ArcheGallery.open(archeItem, images.join('|||'), title, images.length);
    }
  }

  function openStep11ChairFreshGallery(chairItem) {
    const images = collectImagesFromEl(chairItem, 'data-step11-images-full');
    const titleEl = chairItem.querySelector('.table-honneur-title');
    const title = titleEl ? titleEl.textContent.trim() : '';
    if (images.length > 0 && step10ArcheGallery) {
      step10ArcheGallery.open(chairItem, images.join('|||'), title, images.length);
    }
  }

  function openStep11ChairArtificialGallery(chairItem) {
    const chairColorSelect = document.getElementById('chair-color');
    const images = [];
    const selectedColor = chairColorSelect && chairColorSelect.value;
    if (selectedColor) {
      getColorImagesFromSelect(chairColorSelect, selectedColor).forEach(function (u) { images.push(u); });
    }
    if (images.length === 0) collectImagesFromEl(chairItem).forEach(function (u) { images.push(u); });
    if (images.length > 0 && step10ArcheGallery) {
      step10ArcheGallery.open(chairItem, images.join('|||'), '', images.length);
    }
  }

  function openProductCardGallery(cardEl) {
    const images = collectImagesFromEl(cardEl, 'data-product-images-full');
    const titleEl = cardEl.querySelector('.container-item-label, .gift-bag-item-label');
    const title = titleEl ? titleEl.textContent.trim() : '';
    if (images.length > 0 && step10ArcheGallery) {
      step10ArcheGallery.open(cardEl, images.join('|||'), title, images.length);
    }
  }

  function initQuestionnairePresetSwiper(swiperEl) {
    if (!swiperEl || typeof Swiper === 'undefined') return null;
    const count = swiperEl.querySelectorAll('.swiper-slide').length;
    if (count === 0) return null;
    const showNav = count > 1;
    const nextBtn = swiperEl.querySelector('.swiper-button-next');
    const prevBtn = swiperEl.querySelector('.swiper-button-prev');
    const pagination = swiperEl.querySelector('.swiper-pagination');
    if (nextBtn) nextBtn.style.display = showNav ? '' : 'none';
    if (prevBtn) prevBtn.style.display = showNav ? '' : 'none';
    if (pagination) pagination.style.display = showNav ? '' : 'none';
    if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
    return new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      navigation: showNav ? { nextEl: nextBtn, prevEl: prevBtn } : false,
      pagination: showNav ? { el: pagination, clickable: true, type: 'bullets' } : false
    });
  }

  function initStep9SubSwipers(rootEl) {
    const scope = rootEl || document.querySelector('[data-step="9"]');
    if (!scope) return;

    scope.querySelectorAll('.step9-sub-swiper').forEach(function (swiperEl) {
      const card = swiperEl.closest('.table-honneur-suboption');
      const cardId = card ? card.id || '' : '';
      const container = card && card.querySelector('.step9-sub-swiper-container');
      if (container) container.style.display = 'block';
      if (step9SubSwipers[cardId]) {
        step9SubSwipers[cardId].destroy(true, true);
        step9SubSwipers[cardId] = null;
      }
      step9SubSwipers[cardId] = initQuestionnairePresetSwiper(swiperEl);
      if (!step9SubSwipers[cardId] && card) {
        const firstImg = swiperEl.querySelector('.swiper-slide img');
        const thumb = firstImg && (firstImg.getAttribute('src') || firstImg.getAttribute('data-fallback-src'));
        const full = firstImg && (firstImg.getAttribute('data-lightbox-src') || thumb);
        if (thumb) ensureTableHonneurImage(card, thumb, full || thumb);
      }
    });
  }

  function initArcheColorSwiper() {
    const archeColorSelect = document.getElementById('arche-color');
    const archeArtificial = document.getElementById('arche-artificial');
    if (!archeColorSelect || !archeArtificial) return;
    const colorName = archeColorSelect.value;
    if (!colorName) {
      const mainImage = document.getElementById('arche-artificial-main-image');
      if (mainImage) mainImage.style.display = '';
      return;
    }
    const images = getColorImagesFromSelect(archeColorSelect, colorName);
    if (images.length) {
      const thumb = resizeShopifyImageUrl(images[0], 600) || images[0];
      const full = images[images.length - 1] || images[0];
      ensureTableHonneurImage(archeArtificial, thumb, full);
    }
  }

  function initStep9() {
    const step9El = document.querySelector('.questionnaire-step[data-step="9"]');
    const validateStep9 = document.getElementById('validate-step-9');
    const freshOption = document.getElementById('table-honneur-fresh');
    const artificialOption = document.getElementById('table-honneur-artificial');
    const noTableHonneurBtn = document.getElementById('no-table-honneur-btn');
    const colorSelect = document.getElementById('table-honneur-color');
    const freshSuboptionsWrapper = document.getElementById('table-honneur-fresh-suboptions-wrapper');
    const freshSuboptions = step9El
      ? step9El.querySelectorAll('.table-honneur-suboption')
      : document.querySelectorAll('[data-step="9"] .table-honneur-suboption');
    if (!freshOption && !artificialOption && !noTableHonneurBtn) return;

    const tableHonneurPriceEl = artificialOption ? artificialOption.querySelector('.table-honneur-price') : null;
    const domBasePrice = tableHonneurPriceEl
      ? (parsePriceFromText(tableHonneurPriceEl.textContent) || 0)
      : 0;
    const attrBasePrice = artificialOption
      ? (parseFloat(artificialOption.getAttribute('data-base-price')) || 0)
      : 0;
    if (domBasePrice > 0) {
      tableHonneurBasePrice = domBasePrice;
    } else if (attrBasePrice > 0) {
      tableHonneurBasePrice = attrBasePrice;
    }

    function updateStep9ArtificialPriceDisplay(selectedOption) {
      if (!tableHonneurPriceEl) return;
      const hasColor = !!(selectedOption && selectedOption.value);
      const colorPrice = hasColor ? (parseFloat(selectedOption.getAttribute('data-price')) || 0) : 0;
      const displayedPrice = hasColor && colorPrice > 0 ? colorPrice : tableHonneurBasePrice;
      tableHonneurPriceEl.textContent = ((displayedPrice > 0 ? displayedPrice : 0) + ' €');
    }

    function updateStep9ColorHint() {
      const hint = document.getElementById('table-honneur-color-hint');
      const needsColor = tableHonneurChoice === 'artificial' && (!colorSelect || colorSelect.value === '');
      if (hint) hint.hidden = !needsColor;
      if (colorSelect) colorSelect.classList.toggle('needs-color', needsColor);
    }

    function updateStep9Validation() {
      const selectedOption = colorSelect ? colorSelect.options[colorSelect.selectedIndex] : null;
      updateStep9ArtificialPriceDisplay(selectedOption);
      updateStep9ColorHint();
      if (!validateStep9) return;
      if (tableHonneurChoice === 'fresh') {
        validateStep9.disabled = !tableHonneurFreshSuboption;
      } else if (tableHonneurChoice === 'no') {
        validateStep9.disabled = false;
      } else if (tableHonneurChoice === 'artificial') {
        validateStep9.disabled = !colorSelect || colorSelect.value === '';
      } else {
        validateStep9.disabled = true;
      }
    }

    function applyStep9ArtificialColorSelection(selectedOption) {
      const hasColor = !!(selectedOption && selectedOption.value);
      const colorPrice = hasColor ? (parseFloat(selectedOption.getAttribute('data-price')) || 0) : 0;
      const colorImages = hasColor
        ? ((selectedOption.getAttribute('data-color-images') || '').split('|||').map(function (u) { return u.trim(); }).filter(Boolean))
        : [];
      const colorThumb = hasColor
        ? (colorImages[0] || selectedOption.getAttribute('data-image-thumb') || selectedOption.getAttribute('data-image') || '')
        : '';
      const colorFull = hasColor
        ? (colorImages[colorImages.length - 1] || selectedOption.getAttribute('data-image-full') || colorThumb)
        : '';
      const priceToApply = hasColor && colorPrice > 0
        ? colorPrice
        : tableHonneurBasePrice;
      if (tableHonneurChoice === 'artificial') {
        tableHonneurPrice = priceToApply;
      }
      updateStep9ArtificialPriceDisplay(selectedOption);
      if (colorThumb && artificialOption) {
        ensureTableHonneurImage(artificialOption, colorThumb, colorFull || colorThumb);
      }
    }

    function toggleFreshSuboptions(show) {
      if (freshSuboptionsWrapper) {
        freshSuboptionsWrapper.style.display = show ? 'block' : 'none';
      }
      const freshSuboptionsContainer = document.getElementById('table-honneur-fresh-suboptions');
      if (freshSuboptionsContainer) {
        freshSuboptionsContainer.style.display = show ? 'grid' : 'none';
      }
      if (!show) {
        freshSuboptions.forEach(function (sub) { sub.classList.remove('selected'); });
        tableHonneurFreshSuboption = null;
      } else {
        setTimeout(function () { initStep9SubSwipers(); }, 50);
      }
    }

    if (freshOption && !freshOption.dataset.qv2Bound) {
      freshOption.dataset.qv2Bound = '1';
      freshOption.addEventListener('click', function (e) {
        if (e.target.closest('.image-zoom-btn')) return;
        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
          tableHonneurChoice = null;
          toggleFreshSuboptions(false);
          updateStep9Validation();
          return;
        }
        if (artificialOption) artificialOption.classList.remove('selected');
        if (noTableHonneurBtn) noTableHonneurBtn.classList.remove('selected');
        this.classList.add('selected');
        tableHonneurChoice = 'fresh';
        toggleFreshSuboptions(true);
        updateStep9Validation();
      });
    }

    if (artificialOption && !artificialOption.dataset.qv2Bound) {
      artificialOption.dataset.qv2Bound = '1';
      artificialOption.addEventListener('click', function (e) {
        if (e.target.closest('.image-zoom-btn') || e.target.closest('.table-honneur-color-selector')) return;
        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
          tableHonneurChoice = null;
          if (colorSelect) {
            colorSelect.value = '';
            colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            updateStep9Validation();
          }
          return;
        }
        if (freshOption) freshOption.classList.remove('selected');
        if (noTableHonneurBtn) noTableHonneurBtn.classList.remove('selected');
        this.classList.add('selected');
        tableHonneurChoice = 'artificial';
        toggleFreshSuboptions(false);
        if (colorSelect) applyStep9ArtificialColorSelection(colorSelect.options[colorSelect.selectedIndex]);
        updateStep9Validation();
      });
    }

    freshSuboptions.forEach(function (suboption) {
      if (suboption.dataset.qv2Bound) return;
      suboption.dataset.qv2Bound = '1';
      suboption.addEventListener('click', function (e) {
        if (e.target.closest('.image-zoom-btn, .swiper-button-next, .swiper-button-prev, .swiper-pagination')) return;
        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
          tableHonneurFreshSuboption = null;
        } else {
          freshSuboptions.forEach(function (opt) { opt.classList.remove('selected'); });
          this.classList.add('selected');
          tableHonneurFreshSuboption = this.getAttribute('data-suboption');
        }
        updateStep9Validation();
      });
    });

    if (colorSelect && !colorSelect.dataset.qv2Bound) {
      colorSelect.dataset.qv2Bound = '1';
      colorSelect.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];
        if (selectedOption && selectedOption.value) {
          if (freshOption) freshOption.classList.remove('selected');
          if (noTableHonneurBtn) noTableHonneurBtn.classList.remove('selected');
          if (artificialOption) artificialOption.classList.add('selected');
          tableHonneurChoice = 'artificial';
          toggleFreshSuboptions(false);
        }
        applyStep9ArtificialColorSelection(selectedOption);
        updateStep9Validation();
      });
      const initialOption = colorSelect.options[colorSelect.selectedIndex];
      applyStep9ArtificialColorSelection(initialOption);
    }

    setupNoOptionButton(
      noTableHonneurBtn,
      [freshOption, artificialOption],
      function (isActive) {
        if (isActive) {
          tableHonneurChoice = 'no';
          toggleFreshSuboptions(false);
        } else {
          tableHonneurChoice = null;
        }
      },
      updateStep9Validation
    );

    updateStep9Validation();
  }

  function initStep10() {
    const validateStep10 = document.getElementById('validate-step-10');
    const archeFresh = document.getElementById('arche-fresh');
    const archeArtificial = document.getElementById('arche-artificial');
    const archeArtificialPriceEl = document.getElementById('arche-artificial-price');
    const noArcheBtn = document.getElementById('no-arche-btn');
    const archeColorSelect = document.getElementById('arche-color');
    const noSupportBtn = document.getElementById('no-support-btn');
    const supportProductSelect = document.getElementById('support-product-select');
    const supportProductDisplay = document.getElementById('support-product-display');
    if (!archeFresh && !archeArtificial && !supportProductSelect) return;

    archeBasePrice = archeArtificialPriceEl
      ? (parsePriceFromText(archeArtificialPriceEl.textContent) || 0)
      : 0;
    archePrice = archeBasePrice;

    function updateArcheArtificialPriceDisplay() {
      if (!archeArtificialPriceEl) return;
      const displayedPrice = archeChoice === 'artificial'
        ? (archePrice > 0 ? archePrice : archeBasePrice)
        : archeBasePrice;
      archeArtificialPriceEl.textContent = ((displayedPrice > 0 ? displayedPrice : 0) + ' €');
    }

    function updateStep10ColorHint() {
      const hint = document.getElementById('arche-color-hint');
      const needsColor = archeChoice === 'artificial' && (!archeColorSelect || archeColorSelect.value === '');
      if (hint) hint.hidden = !needsColor;
      if (archeColorSelect) archeColorSelect.classList.toggle('needs-color', needsColor);
    }

    function updateStep10Validation() {
      updateArcheArtificialPriceDisplay();
      updateStep10ColorHint();
      if (!validateStep10) return;
      if (!archeChoice) {
        validateStep10.disabled = true;
        return;
      }
      if (archeChoice === 'artificial' && (!archeColorSelect || archeColorSelect.value === '')) {
        validateStep10.disabled = true;
        return;
      }
      validateStep10.disabled = false;
    }

    function changeArcheColorImage(colorName) {
      if (!colorName || !archeArtificial) return;
      const images = getColorImagesFromSelect(archeColorSelect, colorName);
      if (images.length) {
        const thumb = resizeShopifyImageUrl(images[0], 600) || images[0];
        const full = images[images.length - 1] || images[0];
        ensureTableHonneurImage(archeArtificial, thumb, full);
      }
    }

    if (archeFresh && !archeFresh.dataset.qv2Bound) {
      archeFresh.dataset.qv2Bound = '1';
      archeFresh.addEventListener('click', function (e) {
        if (e.target.closest('.image-zoom-btn, .table-honneur-color-selector')) return;
        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
          archeChoice = null;
          archeFlowers = 0;
          archePrice = 0;
        } else {
          if (archeArtificial) archeArtificial.classList.remove('selected');
          if (noArcheBtn) noArcheBtn.classList.remove('selected');
          this.classList.add('selected');
          archeChoice = 'fresh';
          archeFlowers = 25;
          archePrice = 0;
        }
        updateStep10Validation();
      });
    }

    if (archeArtificial && !archeArtificial.dataset.qv2Bound) {
      archeArtificial.dataset.qv2Bound = '1';
      archeArtificial.addEventListener('click', function (e) {
        if (e.target.closest('.image-zoom-btn, .table-honneur-color-selector')) return;
        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
          archeChoice = null;
          archeFlowers = 0;
          archePrice = 0;
        } else {
          if (archeFresh) archeFresh.classList.remove('selected');
          if (noArcheBtn) noArcheBtn.classList.remove('selected');
          this.classList.add('selected');
          archeChoice = 'artificial';
          archeFlowers = 0;
          if (archeColorSelect && archeColorSelect.value) {
            const selectedOption = archeColorSelect.options[archeColorSelect.selectedIndex];
            archePrice = (selectedOption && parseFloat(selectedOption.getAttribute('data-price'))) || 0;
            changeArcheColorImage(archeColorSelect.value);
          } else {
            archePrice = archeBasePrice;
          }
        }
        updateStep10Validation();
      });
    }

    if (archeColorSelect && !archeColorSelect.dataset.qv2Bound) {
      archeColorSelect.dataset.qv2Bound = '1';
      archeColorSelect.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];
        if (selectedOption && selectedOption.value) {
          if (archeFresh) archeFresh.classList.remove('selected');
          if (noArcheBtn) noArcheBtn.classList.remove('selected');
          if (archeArtificial) archeArtificial.classList.add('selected');
          archeChoice = 'artificial';
          archeFlowers = 0;
          archePrice = parseFloat(selectedOption.getAttribute('data-price')) || 0;
          changeArcheColorImage(selectedOption.value);
        } else {
          archePrice = archeChoice === 'artificial' ? archeBasePrice : 0;
        }
        updateStep10Validation();
      });
    }

    setupNoOptionButton(
      noArcheBtn,
      [archeFresh, archeArtificial],
      function (isActive) {
        if (isActive) {
          archeChoice = 'no';
          archeFlowers = 0;
          archePrice = 0;
          if (archeColorSelect) {
            archeColorSelect.value = '';
            archeColorSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          archeChoice = null;
          archeFlowers = 0;
        }
      },
      updateStep10Validation
    );

    function showSupportGallery(supportId) {
      const galleriesRoot = document.getElementById('support-arche-galleries');
      const imagePlaceholder = document.getElementById('support-image-placeholder');
      if (supportSwiper) {
        supportSwiper.destroy(true, true);
        supportSwiper = null;
      }
      if (!galleriesRoot || !supportId) {
        if (imagePlaceholder) imagePlaceholder.style.display = 'block';
        return;
      }
      let activeGallery = null;
      let slideCount = 0;
      galleriesRoot.querySelectorAll('.support-arche-gallery').forEach(function (gallery) {
        const match = gallery.getAttribute('data-support-id') === String(supportId);
        gallery.classList.toggle('is-active', match);
        gallery.classList.toggle('is-inactive', !match);
        if (match) {
          activeGallery = gallery;
          slideCount = gallery.querySelectorAll('.swiper-slide').length;
        } else {
          const swiperEl = gallery.querySelector('.support-image-swiper');
          if (swiperEl && swiperEl.swiper) swiperEl.swiper.destroy(true, true);
        }
      });
      if (!activeGallery || slideCount === 0) {
        const opt = supportProductSelect && supportProductSelect.querySelector('option[value="' + supportId + '"]');
        const images = opt
          ? (opt.getAttribute('data-support-images-thumb') || opt.getAttribute('data-support-images') || '').split('|||').filter(Boolean)
          : [];
        if (images.length && supportProductDisplay) {
          ensureTableHonneurImage(supportProductDisplay, images[0], images[images.length - 1]);
          if (imagePlaceholder) imagePlaceholder.style.display = 'none';
        } else if (imagePlaceholder) {
          imagePlaceholder.style.display = 'block';
        }
        return;
      }
      if (imagePlaceholder) imagePlaceholder.style.display = 'none';
      const swiperEl = activeGallery.querySelector('.support-image-swiper');
      if (swiperEl && swiperEl.swiper) swiperEl.swiper.destroy(true, true);
      supportSwiper = initQuestionnairePresetSwiper(swiperEl);
    }

    function updateSupportProductDisplay(blockId) {
      if (!supportProductSelect || !supportProductDisplay) return;
      const selectedOption = supportProductSelect.querySelector('option[value="' + blockId + '"]');
      if (!selectedOption) {
        supportProductDisplay.style.display = 'none';
        supportChoice = null;
        supportPrice = 0;
        supportForm = null;
        updateStep10Validation();
        return;
      }
      supportProductDisplay.style.display = 'block';
      supportProductDisplay.classList.add('selected');
      const supportId = selectedOption.getAttribute('data-support-id') || blockId;
      const supportTitle = selectedOption.getAttribute('data-support-title') || 'SUPPORT ARCHE';
      const supportPriceValue = parseFloat(selectedOption.getAttribute('data-support-price')) || 0;
      const titleEl = document.getElementById('support-product-title');
      const priceEl = document.getElementById('support-product-price');
      if (titleEl) titleEl.textContent = supportTitle;
      if (priceEl) {
        if (supportPriceValue > 0) {
          priceEl.textContent = supportPriceValue + ' €';
          priceEl.style.display = 'block';
        } else {
          priceEl.style.display = 'none';
        }
      }
      supportChoice = supportId;
      supportPrice = supportPriceValue;
      supportForm = '0';
      showSupportGallery(supportId);
      if (noSupportBtn) noSupportBtn.classList.remove('selected');
      updateStep10Validation();
    }

    if (supportProductSelect && !supportProductSelect.dataset.qv2Bound) {
      supportProductSelect.dataset.qv2Bound = '1';
      supportProductSelect.addEventListener('change', function () {
        const selectedValue = this.value;
        if (selectedValue) {
          updateSupportProductDisplay(selectedValue);
        } else {
          supportProductDisplay.style.display = 'none';
          supportProductDisplay.classList.remove('selected');
          supportChoice = null;
          supportPrice = 0;
          supportForm = null;
          updateStep10Validation();
        }
      });
      const firstOption = supportProductSelect.querySelector('option[selected]');
      if (firstOption && firstOption.value) updateSupportProductDisplay(firstOption.value);
    }

    setupNoOptionButton(
      noSupportBtn,
      supportProductDisplay ? [supportProductDisplay] : [],
      function (isActive) {
        if (isActive) {
          supportChoice = 'no';
          supportPrice = 0;
          supportForm = null;
          if (supportProductSelect) supportProductSelect.value = '';
          if (supportProductDisplay) {
            supportProductDisplay.style.display = 'none';
            supportProductDisplay.classList.remove('selected');
          }
        } else {
          supportChoice = null;
          supportForm = null;
          if (supportProductDisplay) supportProductDisplay.classList.remove('selected');
        }
      },
      updateStep10Validation
    );

    updateStep10Validation();
  }

  function initStep11() {
    const validateStep11 = document.getElementById('validate-step-11');
    const step11Fresh = document.getElementById('step11-fresh-option');
    const step11Artificial = document.getElementById('step11-artificial-option');
    const noChairBtn = document.getElementById('no-chair-btn');
    const chairColorSelect = document.getElementById('chair-color');
    const step11ArtificialPriceEl = document.getElementById('step11-artificial-price');
    const chairQuantitySection = document.getElementById('chair-quantity-section');
    if (!step11Fresh && !step11Artificial && !noChairBtn) return;

    chairBasePrice = step11ArtificialPriceEl
      ? (parsePriceFromText(step11ArtificialPriceEl.textContent) || 0)
      : 0;
    chairPrice = chairBasePrice;

    function updateStep11ArtificialPriceDisplay() {
      if (step11ArtificialPriceEl) {
        step11ArtificialPriceEl.textContent = ((chairPrice > 0 ? chairPrice : 0) + ' €');
      }
    }

    function applyStep11ArtificialColorSelection(selectedOption) {
      const hasColor = !!(selectedOption && selectedOption.value);
      const colorPrice = hasColor ? (parseFloat(selectedOption.getAttribute('data-price')) || 0) : 0;
      chairPrice = hasColor ? colorPrice : (chairChoice === 'artificial' ? chairBasePrice : 0);
      const colorImages = hasColor
        ? ((selectedOption.getAttribute('data-color-images') || '').split('|||').map(function (u) { return u.trim(); }).filter(Boolean))
        : [];
      const colorThumb = hasColor ? (colorImages[0] || selectedOption.getAttribute('data-image') || '') : '';
      const colorFull = hasColor ? (colorImages[colorImages.length - 1] || colorThumb) : '';
      if (step11Artificial && colorThumb) {
        ensureTableHonneurImage(step11Artificial, colorThumb, colorFull || colorThumb);
      }
      updateStep11ArtificialPriceDisplay();
    }

    function updateStep11ColorHint() {
      const hint = document.getElementById('chair-color-hint');
      const needsColor = chairChoice === 'artificial' && (!chairColorSelect || chairColorSelect.value === '');
      if (hint) hint.hidden = !needsColor;
      if (chairColorSelect) chairColorSelect.classList.toggle('needs-color', needsColor);
    }

    function updateStep11Validation() {
      updateStep11ArtificialPriceDisplay();
      updateStep11ColorHint();
      if (!validateStep11) return;
      if (!chairChoice) {
        validateStep11.disabled = true;
        return;
      }
      if (chairChoice === 'artificial' && (!chairColorSelect || chairColorSelect.value === '')) {
        validateStep11.disabled = true;
        return;
      }
      if (chairChoice !== 'no' && chairQuantity === 0) {
        validateStep11.disabled = true;
        return;
      }
      validateStep11.disabled = false;
    }

    function toggleChairQuantitySection(show) {
      if (!chairQuantitySection) return;
      const buttons = chairQuantitySection.querySelectorAll('.chair-quantity-btn');
      if (show) {
        chairQuantitySection.style.display = 'block';
        buttons.forEach(function (btn) {
          btn.disabled = false;
          btn.style.opacity = '1';
          btn.style.pointerEvents = 'auto';
        });
      } else {
        chairQuantitySection.style.display = 'none';
        chairQuantity = 0;
        buttons.forEach(function (btn) {
          btn.disabled = true;
          btn.style.opacity = '0.5';
          btn.style.pointerEvents = 'none';
          btn.classList.remove('selected');
        });
      }
    }

    if (step11Fresh && !step11Fresh.dataset.qv2Bound) {
      step11Fresh.dataset.qv2Bound = '1';
      step11Fresh.addEventListener('click', function (e) {
        if (e.target.closest('.image-zoom-btn, .table-honneur-color-selector')) return;
        if (step11Artificial) step11Artificial.classList.remove('selected');
        if (noChairBtn) noChairBtn.classList.remove('selected');
        this.classList.add('selected');
        chairChoice = 'fresh';
        chairQuantity = 0;
        toggleChairQuantitySection(true);
        updateStep11Validation();
      });
    }

    if (step11Artificial && !step11Artificial.dataset.qv2Bound) {
      step11Artificial.dataset.qv2Bound = '1';
      step11Artificial.addEventListener('click', function (e) {
        if (e.target.closest('.image-zoom-btn, .table-honneur-color-selector')) return;
        if (step11Fresh) step11Fresh.classList.remove('selected');
        if (noChairBtn) noChairBtn.classList.remove('selected');
        this.classList.add('selected');
        chairChoice = 'artificial';
        chairQuantity = 0;
        if (chairColorSelect) applyStep11ArtificialColorSelection(chairColorSelect.options[chairColorSelect.selectedIndex]);
        toggleChairQuantitySection(true);
        updateStep11Validation();
      });
    }

    if (noChairBtn && !noChairBtn.dataset.qv2Bound) {
      noChairBtn.dataset.qv2Bound = '1';
      noChairBtn.addEventListener('click', function () {
        if (step11Fresh) step11Fresh.classList.remove('selected');
        if (step11Artificial) step11Artificial.classList.remove('selected');
        this.classList.toggle('selected');
        if (this.classList.contains('selected')) {
          chairChoice = 'no';
          chairPrice = 0;
          chairQuantity = 0;
          toggleChairQuantitySection(false);
        } else {
          chairChoice = null;
          toggleChairQuantitySection(true);
        }
        updateStep11Validation();
      });
    }

    if (chairColorSelect && !chairColorSelect.dataset.qv2Bound) {
      chairColorSelect.dataset.qv2Bound = '1';
      chairColorSelect.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];
        if (selectedOption && selectedOption.value) {
          if (step11Fresh) step11Fresh.classList.remove('selected');
          if (noChairBtn) noChairBtn.classList.remove('selected');
          if (step11Artificial) step11Artificial.classList.add('selected');
          chairChoice = 'artificial';
          toggleChairQuantitySection(true);
        }
        applyStep11ArtificialColorSelection(selectedOption);
        updateStep11Validation();
      });
    }

    if (chairQuantitySection && !chairQuantitySection.dataset.qv2Bound) {
      chairQuantitySection.dataset.qv2Bound = '1';
      chairQuantitySection.addEventListener('click', function (e) {
        const button = e.target.closest('.chair-quantity-btn');
        if (!button || button.disabled) return;
        chairQuantitySection.querySelectorAll('.chair-quantity-btn').forEach(function (btn) {
          btn.classList.remove('selected');
        });
        button.classList.add('selected');
        chairQuantity = parseInt(button.getAttribute('data-quantity'), 10) || 0;
        updateStep11Validation();
      });
    }

    const chairHelpLink = document.getElementById('chair-help-link');
    const chairHelpModal = document.getElementById('chair-help-modal');
    const chairHelpClose = document.getElementById('chair-help-close');

    function openChairHelpModal() {
      if (!chairHelpModal) return;
      if (chairHelpModal.parentNode !== document.body) {
        document.body.appendChild(chairHelpModal);
      }
      chairHelpModal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeChairHelpModal() {
      if (!chairHelpModal) return;
      chairHelpModal.classList.remove('active');
      document.body.style.overflow = '';
    }

    if (chairHelpLink && !chairHelpLink.dataset.qv2Bound) {
      chairHelpLink.dataset.qv2Bound = '1';
      chairHelpLink.addEventListener('click', function (e) {
        e.preventDefault();
        openChairHelpModal();
      });
    }

    if (chairHelpClose && !chairHelpClose.dataset.qv2Bound) {
      chairHelpClose.dataset.qv2Bound = '1';
      chairHelpClose.addEventListener('click', closeChairHelpModal);
    }

    if (chairHelpModal && !chairHelpModal.dataset.qv2Bound) {
      chairHelpModal.dataset.qv2Bound = '1';
      const modalOverlay = chairHelpModal.querySelector('.modal-overlay');
      if (modalOverlay) modalOverlay.addEventListener('click', closeChairHelpModal);
    }

    if (!document.body.dataset.qv2ChairHelpEsc) {
      document.body.dataset.qv2ChairHelpEsc = '1';
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && chairHelpModal && chairHelpModal.classList.contains('active')) {
          closeChairHelpModal();
        }
      });
    }

    toggleChairQuantitySection(false);
    updateStep11Validation();
  }

  function getFirstAccessoryColorOption(select) {
    if (!select) return null;
    for (let i = 0; i < select.options.length; i++) {
      const opt = select.options[i];
      if (opt && opt.value) return opt;
    }
    return null;
  }

  function updateAccessoryCardPriceDisplay(accessoryCard, selectedOption) {
    const priceElement = accessoryCard && accessoryCard.querySelector('.accessories-price');
    if (!priceElement) return;
    let price = 0;
    if (selectedOption && selectedOption.value) {
      price = parseFloat(selectedOption.getAttribute('data-price')) || 0;
    } else {
      const firstOpt = getFirstAccessoryColorOption(accessoryCard.querySelector('.accessories-color-select'));
      if (firstOpt) {
        price = parseFloat(firstOpt.getAttribute('data-price')) || 0;
      } else {
        price = parseFloat(accessoryCard.getAttribute('data-accessory-first-price')) || 0;
      }
    }
    priceElement.textContent = (price > 0 ? price : 0) + ' €';
  }

  function initStep12AccessoryDefaultPrices() {
    document.querySelectorAll('.step12-accessories-option').forEach(function (card) {
      const select = card.querySelector('.accessories-color-select');
      const selectedOption = select && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
      updateAccessoryCardPriceDisplay(card, selectedOption);
    });
  }

  function getAccessoryColorsForCard(card) {
    const colors = {};
    const select = card && card.querySelector('.accessories-color-select');
    if (!select) return colors;
    Array.from(select.options).forEach(function (opt) {
      if (!opt.value) return;
      const images = getColorImagesFromSelect(select, opt.value);
      colors[opt.value] = {
        price: parseFloat(opt.getAttribute('data-price')) || 0,
        images: images,
        imageCount: images.length
      };
    });
    return colors;
  }

  function applyAccessoryCardImage(accessoryCard, imageUrls) {
    if (!accessoryCard || !imageUrls || !imageUrls.length) return;
    const thumb = resizeShopifyImageUrl(imageUrls[0], 400) || imageUrls[0];
    const lb = imageUrls[imageUrls.length - 1] || thumb;
    const wrap = accessoryCard.querySelector('.accessory-item-image, .container-item-image');
    const img = wrap && wrap.querySelector('img');
    if (img) {
      forceLoadImage(img, thumb, lb);
      const zoom = accessoryCard.querySelector('.image-zoom-btn');
      if (zoom) zoom.setAttribute('data-lightbox-src', lb);
    } else {
      ensureTableHonneurImage(accessoryCard, thumb, lb);
    }
  }

  function initStep12() {
    const validateStep12 = document.getElementById('validate-step-12');
    const step12AccessoriesOptions = document.querySelectorAll('.step12-accessories-option');
    const step12NoOption = document.getElementById('step12-no-option');
    if (!step12AccessoriesOptions.length && !step12NoOption) return;

    function checkStep12ColorSelection() {
      if (accessoriesChoice !== 'accessories') return true;
      const missing = [];
      document.querySelectorAll('.step12-accessories-option.selected').forEach(function (accessory) {
        const colorSelect = accessory.querySelector('.accessories-color-select');
        if (!colorSelect || colorSelect.value === '') {
          const title = accessory.querySelector('.table-honneur-title');
          missing.push(title ? title.textContent.trim() : 'cet accessoire');
        }
      });
      if (missing.length) {
        alert('Veuillez sélectionner une couleur pour : ' + missing.join(', '));
        return false;
      }
      return true;
    }

    function recalcAccessoriesPrice() {
      let totalPrice = 0;
      document.querySelectorAll('.step12-accessories-option.selected').forEach(function (accessory) {
        const priceEl = accessory.querySelector('.accessories-price');
        const qtyInput = accessory.querySelector('.quantity-input');
        if (priceEl && qtyInput) {
          const priceText = priceEl.textContent.replace(' €', '').trim();
          const qty = parseInt(qtyInput.value, 10) || 0;
          totalPrice += (parseFloat(priceText) || 0) * qty;
        }
      });
      accessoriesPrice = totalPrice;
    }

    function updateStep12ColorHints() {
      step12AccessoriesOptions.forEach(function (card) {
        const hint = card.querySelector('.table-honneur-color-hint');
        const colorSelect = card.querySelector('.accessories-color-select');
        const needsColor = card.classList.contains('selected') && (!colorSelect || colorSelect.value === '');
        if (hint) hint.hidden = !needsColor;
        if (colorSelect) colorSelect.classList.toggle('needs-color', needsColor);
      });
    }

    function updateStep12Validation() {
      updateStep12ColorHints();
      if (!validateStep12) return;
      if (!accessoriesChoice) {
        validateStep12.disabled = true;
        return;
      }
      if (accessoriesChoice === 'accessories') {
        let hasQuantity = false;
        let missingColor = false;
        document.querySelectorAll('.step12-accessories-option.selected').forEach(function (accessory) {
          const accessoryId = accessory.getAttribute('data-accessory-id');
          const quantityInput = accessory.querySelector('#accessory-quantity-' + accessoryId);
          if (quantityInput && parseInt(quantityInput.value, 10) > 0) hasQuantity = true;
          const colorSelect = accessory.querySelector('.accessories-color-select');
          if (!colorSelect || colorSelect.value === '') missingColor = true;
        });
        validateStep12.disabled = !hasQuantity || missingColor;
        return;
      }
      validateStep12.disabled = false;
    }

    step12AccessoriesOptions.forEach(function (option) {
      if (option.dataset.qv2Bound) return;
      option.dataset.qv2Bound = '1';
      option.addEventListener('click', function (e) {
        if (e.target.closest('select, button, input, .image-zoom-btn')) return;
        if (step12NoOption) step12NoOption.classList.remove('selected');
        const accessoryId = this.getAttribute('data-accessory-id');
        const quantityInput = this.querySelector('#accessory-quantity-' + accessoryId);
        const minusBtn = this.querySelector('.quantity-minus[data-accessory-id="' + accessoryId + '"]');
        const plusBtn = this.querySelector('.quantity-plus[data-accessory-id="' + accessoryId + '"]');
        if (!quantityInput || !plusBtn) return;
        if (parseInt(quantityInput.value, 10) === 0) {
          quantityInput.value = 1;
          quantityInput.disabled = false;
          if (minusBtn) minusBtn.disabled = false;
          this.classList.add('selected');
          accessoriesChoice = 'accessories';
        } else {
          quantityInput.value = 0;
          quantityInput.disabled = true;
          if (minusBtn) minusBtn.disabled = true;
          this.classList.remove('selected');
          if (!document.querySelector('.step12-accessories-option.selected')) accessoriesChoice = null;
        }
        recalcAccessoriesPrice();
        updateStep12Validation();
      });

      const accessoryId = option.getAttribute('data-accessory-id');
      const quantityInput = option.querySelector('#accessory-quantity-' + accessoryId);
      const minusBtn = option.querySelector('.quantity-minus[data-accessory-id="' + accessoryId + '"]');
      const plusBtn = option.querySelector('.quantity-plus[data-accessory-id="' + accessoryId + '"]');
      if (quantityInput && minusBtn && plusBtn) {
        function updateQuantityState() {
          const currentValue = parseInt(quantityInput.value, 10) || 0;
          minusBtn.disabled = currentValue <= 0;
          quantityInput.disabled = currentValue <= 0;
          option.classList.toggle('selected', currentValue > 0);
          if (currentValue > 0) {
            accessoriesChoice = 'accessories';
          } else if (!document.querySelector('.step12-accessories-option.selected')) {
            accessoriesChoice = null;
          }
          recalcAccessoriesPrice();
          updateStep12Validation();
        }
        minusBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (step12NoOption && step12NoOption.classList.contains('selected')) return;
          let currentValue = parseInt(quantityInput.value, 10) || 0;
          if (currentValue > 0) {
            quantityInput.value = currentValue - 1;
            updateQuantityState();
          }
        });
        plusBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (step12NoOption && step12NoOption.classList.contains('selected')) return;
          quantityInput.value = (parseInt(quantityInput.value, 10) || 0) + 1;
          quantityInput.disabled = false;
          minusBtn.disabled = false;
          updateQuantityState();
        });
        updateQuantityState();
      }

      const colorSelect = option.querySelector('.accessories-color-select');
      if (colorSelect && !colorSelect.dataset.qv2Bound) {
        colorSelect.dataset.qv2Bound = '1';
        colorSelect.addEventListener('change', function (e) {
          e.stopPropagation();
          const accessoryCard = this.closest('.step12-accessories-option');
          const accessoryId = accessoryCard.getAttribute('data-accessory-id');
          if (this.value) {
            if (step12NoOption) step12NoOption.classList.remove('selected');
            accessoryCard.classList.add('selected');
            accessoriesChoice = 'accessories';
            const quantityInput = accessoryCard.querySelector('#accessory-quantity-' + accessoryId);
            const minusBtn = accessoryCard.querySelector('.quantity-minus[data-accessory-id="' + accessoryId + '"]');
            if (quantityInput) {
              if ((parseInt(quantityInput.value, 10) || 0) <= 0) quantityInput.value = 1;
              quantityInput.disabled = false;
            }
            if (minusBtn) minusBtn.disabled = false;
            const colors = getAccessoryColorsForCard(accessoryCard);
            const colorData = colors[this.value];
            if (colorData) {
              updateAccessoryCardPriceDisplay(accessoryCard, this.options[this.selectedIndex]);
              if (colorData.images.length) applyAccessoryCardImage(accessoryCard, colorData.images);
            }
          } else {
            updateAccessoryCardPriceDisplay(accessoryCard, null);
          }
          recalcAccessoriesPrice();
          updateStep12Validation();
        });
      }
    });

    if (step12NoOption && !step12NoOption.dataset.qv2Bound) {
      step12NoOption.dataset.qv2Bound = '1';
      step12NoOption.addEventListener('click', function () {
        step12AccessoriesOptions.forEach(function (opt) {
          opt.classList.remove('selected');
          const accessoryId = opt.getAttribute('data-accessory-id');
          const quantityInput = document.getElementById('accessory-quantity-' + accessoryId);
          const minusBtn = opt.querySelector('.quantity-minus[data-accessory-id="' + accessoryId + '"]');
          if (quantityInput) {
            quantityInput.value = 0;
            quantityInput.disabled = true;
            if (minusBtn) minusBtn.disabled = true;
          }
        });
        this.classList.toggle('selected');
        accessoriesChoice = this.classList.contains('selected') ? 'no' : null;
        accessoriesPrice = 0;
        updateStep12Validation();
      });
    }

    if (validateStep12 && !validateStep12.dataset.qv2ColorCheck) {
      validateStep12.dataset.qv2ColorCheck = '1';
      validateStep12.addEventListener('click', function (e) {
        if (!checkStep12ColorSelection()) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);
    }

    initStep12AccessoryDefaultPrices();
    updateStep12Validation();
  }

  function initStep13() {
    const validateStep13Btn = document.getElementById('validate-step-13');
    const containerItems = document.querySelectorAll('.container-item');
    const noContainersOption = document.getElementById('step13-no-containers-option');
    const giftBagItems = document.querySelectorAll('.gift-bag-item');
    const noGiftBagsBtn = document.getElementById('no-gift-bags-btn');
    if (!containerItems.length && !giftBagItems.length) return;

    function updateStep13Validation() {
      if (!validateStep13Btn) return;
      const hasSelectedContainer = document.querySelector('.container-item.selected');
      const hasNoContainersSelected = noContainersOption && noContainersOption.classList.contains('selected');
      validateStep13Btn.disabled = !(hasSelectedContainer || hasNoContainersSelected);
    }

    function bindQuantityItem(item, idAttr, prefix) {
      const itemId = item.getAttribute(idAttr);
      const quantityInput = item.querySelector('#' + prefix + '-quantity-' + itemId);
      const minusBtn = item.querySelector('.quantity-minus[' + idAttr + '="' + itemId + '"]');
      const plusBtn = item.querySelector('.quantity-plus[' + idAttr + '="' + itemId + '"]');
      if (!quantityInput || !minusBtn || !plusBtn) return;

      function updateQuantityState() {
        const currentValue = parseInt(quantityInput.value, 10) || 0;
        minusBtn.disabled = currentValue <= 0;
        quantityInput.disabled = currentValue <= 0;
        item.classList.toggle('selected', currentValue > 0);
        updateStep13Validation();
      }

      minusBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        const currentValue = parseInt(quantityInput.value, 10) || 0;
        if (currentValue > 0) {
          quantityInput.value = currentValue - 1;
          updateQuantityState();
        }
      });
      plusBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        quantityInput.value = (parseInt(quantityInput.value, 10) || 0) + 1;
        updateQuantityState();
      });
      updateQuantityState();
    }

    containerItems.forEach(function (item) {
      if (item.dataset.qv2Bound) return;
      item.dataset.qv2Bound = '1';
      bindQuantityItem(item, 'data-container-id', 'container');
      item.addEventListener('click', function (e) {
        if (e.target.closest('.image-zoom-btn, .quantity-selector, .quantity-btn')) return;
        const containerId = this.getAttribute('data-container-id');
        const quantityInput = this.querySelector('#container-quantity-' + containerId);
        const minusBtn = this.querySelector('.quantity-minus[data-container-id="' + containerId + '"]');
        if (!quantityInput) return;
        if (parseInt(quantityInput.value, 10) === 0) {
          quantityInput.value = 1;
          quantityInput.disabled = false;
          if (minusBtn) minusBtn.disabled = false;
          this.classList.add('selected');
        } else {
          quantityInput.value = 0;
          quantityInput.disabled = true;
          if (minusBtn) minusBtn.disabled = true;
          this.classList.remove('selected');
        }
        if (noContainersOption) noContainersOption.classList.remove('selected');
        updateStep13Validation();
      });
    });

    giftBagItems.forEach(function (item) {
      if (item.dataset.qv2Bound) return;
      item.dataset.qv2Bound = '1';
      bindQuantityItem(item, 'data-gift-bag-id', 'gift-bag');
      item.addEventListener('click', function (e) {
        if (e.target.closest('.image-zoom-btn, .quantity-selector, .quantity-btn')) return;
        const giftBagId = this.getAttribute('data-gift-bag-id');
        const quantityInput = this.querySelector('#gift-bag-quantity-' + giftBagId);
        const minusBtn = this.querySelector('.quantity-minus[data-gift-bag-id="' + giftBagId + '"]');
        if (!quantityInput) return;
        if (parseInt(quantityInput.value, 10) === 0) {
          quantityInput.value = 1;
          quantityInput.disabled = false;
          if (minusBtn) minusBtn.disabled = false;
          this.classList.add('selected');
        } else {
          quantityInput.value = 0;
          quantityInput.disabled = true;
          if (minusBtn) minusBtn.disabled = true;
          this.classList.remove('selected');
        }
        if (noGiftBagsBtn) noGiftBagsBtn.classList.remove('selected');
        updateStep13Validation();
      });
    });

    if (noContainersOption && !noContainersOption.dataset.qv2Bound) {
      noContainersOption.dataset.qv2Bound = '1';
      noContainersOption.addEventListener('click', function () {
        containerItems.forEach(function (item) {
          item.classList.remove('selected');
          const containerId = item.getAttribute('data-container-id');
          const quantityInput = item.querySelector('#container-quantity-' + containerId);
          const minusBtn = item.querySelector('.quantity-minus[data-container-id="' + containerId + '"]');
          if (quantityInput) {
            quantityInput.value = 0;
            quantityInput.disabled = true;
            if (minusBtn) minusBtn.disabled = true;
          }
        });
        this.classList.toggle('selected');
        updateStep13Validation();
      });
    }

    if (noGiftBagsBtn && !noGiftBagsBtn.dataset.qv2Bound) {
      noGiftBagsBtn.dataset.qv2Bound = '1';
      noGiftBagsBtn.addEventListener('click', function (e) {
        e.preventDefault();
        giftBagItems.forEach(function (item) {
          item.classList.remove('selected');
          const giftBagId = item.getAttribute('data-gift-bag-id');
          const quantityInput = item.querySelector('#gift-bag-quantity-' + giftBagId);
          const minusBtn = item.querySelector('.quantity-minus[data-gift-bag-id="' + giftBagId + '"]');
          if (quantityInput) {
            quantityInput.value = 0;
            quantityInput.disabled = true;
            if (minusBtn) minusBtn.disabled = true;
          }
        });
        this.classList.toggle('selected');
        updateStep13Validation();
      });
    }

    const containersCalculLink = document.getElementById('containers-calcul-link');
    const containersCalculModal = document.getElementById('containers-calcul-modal');
    const containersCalculModalClose = document.getElementById('containers-calcul-modal-close');
    const containersCalculResults = document.getElementById('containers-calcul-results');

    function resolveContainerTypeFromLabel(label) {
      const titleUpper = (label || '').toUpperCase();
      if (titleUpper.indexOf('SOLIFLORE') !== -1) return 'soliflore';
      if (titleUpper.indexOf('VASE') !== -1) return 'vase';
      if (titleUpper.indexOf('COUPELLE') !== -1 || titleUpper.indexOf('DORÉE') !== -1 || titleUpper.indexOf('DOREE') !== -1) {
        return 'coupelle';
      }
      return null;
    }

    function normalizeContainerTypeKey(type) {
      return type === 'pique' ? 'coupelle' : type;
    }

    function setContainerItemQuantity(item, qty) {
      if (!item) return;
      const containerId = item.getAttribute('data-container-id');
      const quantityInput = item.querySelector('#container-quantity-' + containerId);
      const minusBtn = item.querySelector('.quantity-minus[data-container-id="' + containerId + '"]');
      if (!quantityInput) return;
      const value = Math.max(0, parseInt(qty, 10) || 0);
      quantityInput.value = String(value);
      quantityInput.disabled = value <= 0;
      if (minusBtn) minusBtn.disabled = value <= 0;
      item.classList.toggle('selected', value > 0);
    }

    function getQuestion6Data() {
      const selectedElements = document.querySelectorAll('.element-item.selected');
      let hasTableTraiteurs = false;
      let hasMangeDebout = false;
      selectedElements.forEach(function (element) {
        const label = element.querySelector('.element-item-label');
        const titleUpper = (label ? label.textContent : '').trim().toUpperCase();
        if (titleUpper.indexOf('TRAITEUR') !== -1) hasTableTraiteurs = true;
        if (
          titleUpper.indexOf('MANGE') !== -1 ||
          titleUpper.indexOf('DEBOUT') !== -1 ||
          titleUpper.indexOf('TABLES HAUTES') !== -1 ||
          (titleUpper.indexOf('VIN') !== -1 && titleUpper.indexOf('HONNEUR') !== -1 && titleUpper.indexOf('TRAITEUR') === -1)
        ) {
          hasMangeDebout = true;
        }
      });
      return { hasTableTraiteurs: hasTableTraiteurs, hasMangeDebout: hasMangeDebout };
    }

    function getQuestion7Data() {
      const selectedDecoration = document.querySelector('.decoration-item.selected');
      const tablesInput = document.getElementById('tables-quantity');
      const tablesCount = tablesInput ? (parseInt(tablesInput.value, 10) || 0) : 0;
      let decorationType = null;
      let decorationTitle = null;
      if (selectedDecoration) {
        const label = selectedDecoration.querySelector('.decoration-item-label');
        decorationTitle = selectedDecoration.getAttribute('data-decoration-title') || (label ? label.textContent.trim() : '');
        const titleUpper = (decorationTitle || '').toUpperCase();
        if (titleUpper.indexOf('SOLIFLORE') !== -1) decorationType = 'soliflore';
        else if (titleUpper.indexOf('VASE') !== -1) decorationType = 'vase';
        else if (titleUpper.indexOf('COUPELLE') !== -1 || titleUpper.indexOf('DORÉE') !== -1 || titleUpper.indexOf('DOREE') !== -1) {
          decorationType = 'coupelle';
        }
      }
      return { type: decorationType, title: decorationTitle, tablesCount: tablesCount };
    }

    function getQuestion9Data() {
      const selectedOption = document.querySelector('.questionnaire-table-honneur-options .table-honneur-option.selected');
      const noOption = document.querySelector('.no-table-honneur-btn.selected');
      const hasTableHonneur = !!(selectedOption && !noOption);
      const selectedFreshSuboption = document.querySelector('.table-honneur-suboption.selected');
      let containerType = null;
      let containerQuantity = 0;
      if (selectedFreshSuboption) {
        const suboptionKey = selectedFreshSuboption.getAttribute('data-suboption') || '';
        const titleEl = selectedFreshSuboption.querySelector('.table-honneur-title');
        const titleUpper = (titleEl ? titleEl.textContent : '').trim().toUpperCase();
        if (suboptionKey.indexOf('soliflore') !== -1 || titleUpper.indexOf('SOLIFLORE') !== -1) {
          containerType = 'soliflore';
          containerQuantity = 3;
        } else if (suboptionKey.indexOf('vase') !== -1 || titleUpper.indexOf('VASE') !== -1) {
          containerType = 'vase';
          containerQuantity = 2;
        } else if (
          suboptionKey.indexOf('pique') !== -1 ||
          suboptionKey.indexOf('composition') !== -1 ||
          titleUpper.indexOf('COUPELLE') !== -1 ||
          titleUpper.indexOf('DORÉE') !== -1 ||
          titleUpper.indexOf('DOREE') !== -1 ||
          titleUpper.indexOf('PIQU') !== -1
        ) {
          containerType = 'coupelle';
          containerQuantity = suboptionKey.indexOf('grosse') !== -1 || titleUpper.indexOf('GROSSE') !== -1 ? 1 : 2;
        }
      }
      return {
        hasTableHonneur: hasTableHonneur,
        containerType: containerType,
        containerQuantity: containerQuantity
      };
    }

    function calculateContainersQuantities() {
      const question7Data = getQuestion7Data();
      const question9Data = getQuestion9Data();
      const question6Data = getQuestion6Data();
      const results = {
        decorationTitle: question7Data.title || null,
        tablesCount: question7Data.tablesCount || 0,
        soliflores: 0,
        coupelle: 0,
        vase: 0,
        hasTableHonneur: question9Data.hasTableHonneur || false,
        hasTableTraiteurs: question6Data.hasTableTraiteurs || false,
        hasMangeDebout: question6Data.hasMangeDebout || false
      };
      if (question7Data.type === 'soliflore') results.soliflores = results.tablesCount;
      else if (question7Data.type === 'vase') results.vase = results.tablesCount;
      else if (question7Data.type === 'coupelle') results.coupelle = results.tablesCount;

      if (results.hasTableHonneur && question9Data.containerType) {
        if (question9Data.containerType === 'soliflore') results.soliflores += 3;
        else if (question9Data.containerType === 'vase') results.vase += 2;
        else if (question9Data.containerType === 'coupelle') results.coupelle += question9Data.containerQuantity || 2;
      }
      if (results.hasTableTraiteurs) results.soliflores += 2;
      if (results.hasMangeDebout) results.soliflores += 4;
      return results;
    }

    function applyContainersRecommendations(quantities) {
      if (!quantities || !containerItems.length) return;
      const typeQty = {
        soliflore: quantities.soliflores || 0,
        vase: quantities.vase || 0,
        coupelle: quantities.coupelle || 0
      };
      if (!(typeQty.soliflore > 0 || typeQty.vase > 0 || typeQty.coupelle > 0)) return;
      if (noContainersOption) noContainersOption.classList.remove('selected');
      const appliedByType = { soliflore: false, vase: false, coupelle: false };
      containerItems.forEach(function (item) {
        const typeAttr = normalizeContainerTypeKey(item.getAttribute('data-container-type'));
        const label = item.querySelector('.container-item-label');
        const type = typeAttr || resolveContainerTypeFromLabel(label ? label.textContent.trim() : '');
        if (type && typeQty[type] > 0 && !appliedByType[type]) {
          setContainerItemQuantity(item, typeQty[type]);
          appliedByType[type] = true;
        } else {
          setContainerItemQuantity(item, 0);
        }
      });
      updateStep13Validation();
    }

    function renderContainersCalcul(quantities) {
      let html = '<div class="containers-calcul-section">';
      html += '<div class="containers-calcul-section-label">Vous avez choisi</div>';
      if (quantities.decorationTitle) {
        html += '<div class="containers-calcul-choice decoration-title">' + quantities.decorationTitle.toUpperCase() + '</div>';
      }
      if (quantities.tablesCount > 0) {
        html += '<div class="containers-calcul-choice tables-count">' + quantities.tablesCount + ' TABLES DES INVITÉS</div>';
      }
      html += '</div>';

      const indicatedItems = [];
      if (quantities.hasTableHonneur) indicatedItems.push("TABLE D'HONNEUR");
      if (quantities.hasTableTraiteurs) indicatedItems.push('TABLE DES TRAITEURS');
      if (quantities.hasMangeDebout) indicatedItems.push("MANGE DEBOUT (VIN D'HONNEUR)");
      if (indicatedItems.length > 0) {
        html += '<div class="containers-calcul-section"><div class="containers-calcul-indicated-box">';
        html += '<div class="containers-calcul-section-label">Vous nous avez indiqué :</div>';
        indicatedItems.forEach(function (item) {
          const isActive = item !== "MANGE DEBOUT (VIN D'HONNEUR)";
          html += '<div class="containers-calcul-indicated-item' + (isActive ? ' active' : ' inactive') + '">' + item + '</div>';
        });
        html += '</div></div>';
      }

      const recommendations = [];
      if (quantities.vase > 0) recommendations.push(quantities.vase + ' VASES');
      if (quantities.soliflores > 0) recommendations.push(quantities.soliflores + ' PACK SOLIFLORES');
      if (quantities.coupelle > 0) {
        recommendations.push(quantities.coupelle + ' ' + (quantities.coupelle > 1 ? 'COUPELLES DORÉES' : 'COUPELLE DORÉE'));
      }
      if (recommendations.length > 0) {
        html += '<div class="containers-calcul-section">';
        html += '<div class="containers-calcul-section-label">Nous vous conseillons :</div>';
        html += '<div class="containers-calcul-recommendation-box">';
        recommendations.forEach(function (text, index) {
          if (index > 0) html += '<div class="containers-calcul-recommendation-connector">ET</div>';
          html += '<div class="containers-calcul-recommendation-item">' + text + '</div>';
        });
        html += '</div></div>';
      }
      return html;
    }

    function openContainersCalculModal() {
      if (!containersCalculModal) return;
      const quantities = calculateContainersQuantities();
      if (containersCalculResults) containersCalculResults.innerHTML = renderContainersCalcul(quantities);
      applyContainersRecommendations(quantities);
      if (containersCalculModal.parentNode !== document.body) {
        document.body.appendChild(containersCalculModal);
      }
      containersCalculModal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeContainersCalculModal() {
      if (!containersCalculModal) return;
      containersCalculModal.classList.remove('active');
      document.body.style.overflow = '';
    }

    if (containersCalculLink && !containersCalculLink.dataset.qv2Bound) {
      containersCalculLink.dataset.qv2Bound = '1';
      containersCalculLink.addEventListener('click', function (e) {
        e.preventDefault();
        openContainersCalculModal();
      });
    }

    if (containersCalculModalClose && !containersCalculModalClose.dataset.qv2Bound) {
      containersCalculModalClose.dataset.qv2Bound = '1';
      containersCalculModalClose.addEventListener('click', function (e) {
        e.preventDefault();
        closeContainersCalculModal();
      });
    }

    if (containersCalculModal && !containersCalculModal.dataset.qv2Bound) {
      containersCalculModal.dataset.qv2Bound = '1';
      const overlay = containersCalculModal.querySelector('.modal-overlay');
      if (overlay) overlay.addEventListener('click', closeContainersCalculModal);
    }

    if (!document.body.dataset.qv2ContainersCalculEsc) {
      document.body.dataset.qv2ContainersCalculEsc = '1';
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && containersCalculModal && containersCalculModal.classList.contains('active')) {
          closeContainersCalculModal();
        }
      });
    }

    updateStep13Validation();
  }

  function initGalleries() {
    if (!step9SubGallery && document.getElementById('step9-sub-gallery-modal')) {
      step9SubGallery = new ImageGalleryModal({
        modalId: 'step9-sub-gallery-modal',
        imageId: 'step9-sub-modal-image',
        counterId: 'step9-sub-modal-counter',
        titleId: 'step9-sub-modal-title',
        prevId: 'step9-sub-modal-prev',
        nextId: 'step9-sub-modal-next',
        closeId: 'step9-sub-modal-close'
      });
    }
    if (!step10ArcheGallery && document.getElementById('step10-arche-gallery-modal')) {
      step10ArcheGallery = new ImageGalleryModal({
        modalId: 'step10-arche-gallery-modal',
        imageId: 'step10-arche-modal-image',
        counterId: 'step10-arche-modal-counter',
        titleId: 'step10-arche-modal-title',
        prevId: 'step10-arche-modal-prev',
        nextId: 'step10-arche-modal-next',
        closeId: 'step10-arche-modal-close'
      });
    }
  }

  function initSwipers(stepNumber) {
    runWhenSwiperReady(function (ready) {
      if (!ready) return;
      if (stepNumber === 9) {
        initStep9SubSwipers(document.querySelector('[data-step="9"]'));
      }
      if (stepNumber === 10) {
        initArcheColorSwiper();
      }
    });
  }

  function initSteps0913() {
    if (!document.querySelector('[data-qv2-section="09-13"]') &&
        !document.getElementById('validate-step-9') &&
        !document.getElementById('validate-step-13')) {
      return;
    }
    if (window.QV2 && typeof window.QV2.ensureSharedUiInBody === 'function') {
      window.QV2.ensureSharedUiInBody();
    }
    initLightboxBindings();
    initZoomDelegation();
    initGalleries();
    initStep9();
    initStep10();
    initStep11();
    initStep12();
    initStep13();
    initialized = true;
  }

  function onStepShown(stepNumber) {
    if (stepNumber >= 9 && stepNumber <= 13) {
      initSteps0913();
      getQuestionnaireMediaData(true);
      hydrateQuestionnaireStepMedia(stepNumber);
      initSwipers(stepNumber);
      const stepEl = document.querySelector('.questionnaire-step[data-step="' + stepNumber + '"]');
      window.requestAnimationFrame(function () {
        fixBrokenImagesInStep(stepEl);
      });
      setTimeout(function () {
        fixBrokenImagesInStep(stepEl);
        initSwipers(stepNumber);
      }, 600);
    }
  }

  function hydrateVisibleSteps0913() {
    for (let step = 9; step <= 13; step++) {
      const stepEl = document.querySelector('.questionnaire-step[data-step="' + step + '"]');
      if (stepEl && stepEl.style.display !== 'none') {
        hydrateQuestionnaireStepMedia(step);
      }
    }
  }

  document.addEventListener('qv2:mediaDataUpdated', function () {
    invalidateQuestionnaireMediaCache();
    hydrateVisibleSteps0913();
  });

  window.QV2_STEPS_09_13 = {
    init: initSteps0913,
    onStepShown: onStepShown,
    initSwipers: initSwipers,
    getState: function () {
      return {
        tableHonneurChoice: tableHonneurChoice,
        tableHonneurFreshSuboption: tableHonneurFreshSuboption,
        tableHonneurPrice: tableHonneurPrice,
        archeChoice: archeChoice,
        archeFlowers: archeFlowers,
        archePrice: archePrice,
        chairChoice: chairChoice,
        chairQuantity: chairQuantity,
        chairPrice: chairPrice
      };
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSteps0913);
  } else {
    initSteps0913();
  }
})();
